var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path && _vm.$route.path !== '/')?[(_vm.$route.path === '/login')?[_c('router-view',{key:_vm.$route.fullPath})]:[_c('NavMenu'),_c('router-view',{key:_vm.$route.fullPath})]]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }